import React from "react";
import { observer } from "mobx-react-lite";
import { Col, Row } from "react-bootstrap";
import type { ViewComponent } from "@frui.ts/views";
import { registerView } from "@frui.ts/views";
import OrderSectionView from "../detail/orderSectionView";
import TransferRefundForRefundOfRefundPaymentSectionView from "./transferRefundForRefundOfRefundPaymentSectionView";
import TransferRefundForRefundOfRefundOriginalPaymentView from "./transferRefundForRefundOfRefundOriginalPaymentView";
import RefundForRefundOfRefundDetailView from "../refundForRefundOfRefundDetailView";
import RefundForRefundOfRefundPaymentSectionView from "../detail/refundForRefundOfRefundsPaymentSectionView";
import DomesticRefundForRefundOfRefundsDetailViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/domestic/domesticRefundForRefundOfRefundsDetailViewModel";
import ForeignRefundForRefundOfRefundsDetailViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/foreign/foreignRefundForRefundOfRefundsDetailViewModel";
import SEPARefundForRefundOfRefundsDetailViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/SEPA/SEPARefundForRefundOfRefundsDetailViewModel";
import type TransferRefundForRefundOfRefundsDetailViewModel from "viewModels/finance/refundForRefundOfRefunds/transferRefundForRefundOfRefunds/transferRefundForRefundOfRefundsDetailViewModel";

const TransferRefundForRefundOfRefundsDetailView: ViewComponent<TransferRefundForRefundOfRefundsDetailViewModel> = observer(
  ({ vm }) => {
    return (
      <RefundForRefundOfRefundDetailView vm={vm}>
        <Row className="mb-4">
          <Col>
            <OrderSectionView vm={vm} />
          </Col>
        </Row>
        <Row>
          <Col lg={12} xl={6} className="mb-4">
            <TransferRefundForRefundOfRefundPaymentSectionView vm={vm} />
            <TransferRefundForRefundOfRefundOriginalPaymentView vm={vm} />
          </Col>
          <Col lg={12} xl={6} className="mb-4">
            <RefundForRefundOfRefundPaymentSectionView vm={vm} />
          </Col>
        </Row>
      </RefundForRefundOfRefundDetailView>
    );
  }
);

registerView(TransferRefundForRefundOfRefundsDetailView, DomesticRefundForRefundOfRefundsDetailViewModel);
registerView(TransferRefundForRefundOfRefundsDetailView, ForeignRefundForRefundOfRefundsDetailViewModel);
registerView(TransferRefundForRefundOfRefundsDetailView, SEPARefundForRefundOfRefundsDetailViewModel);
